import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { SlickCarouselModule } from 'ngx-slick-carousel';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './common/home/home.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { ServicesModule } from './services/services.module';
import { IndustriesModule } from './industries/industries.module';
import { CareersModule } from './careers/careers.module';

import { register } from 'swiper/element/bundle';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDialogModule} from '@angular/material/dialog';
import { SharedModule } from './shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MiteventsComponent } from './common/mitevents/mitevents.component';
import { ContactComponent } from './common/contact/contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { CareersRoutingModule } from './careers/careers-routing.module';
import { InsightsRoutingModule } from './insights/insights-routing.module';
import { ServicesRoutingModule } from './services/services-routing.module';
import { IndustriesRoutingModule } from './industries/industries-routing.module';
import { AboutModule } from './about/about.module';
import { SingleEventComponent } from './common/single-event/single-event.component';
import { MatCardModule } from '@angular/material/card';
import { FutekCasestudyComponent } from './industries/futek-casestudy/futek-casestudy.component';
import { CommonModule } from '@angular/common';
import { InsightsModule } from './insights/insights.module';
import { EventfooterComponent } from './common/eventfooter/eventfooter.component';
import { PrivacyComponent } from './common/privacy/privacy.component';
import { TermsandConditionsComponent } from './common/termsand-conditions/termsand-conditions.component';
import { CancellationComponent } from './common/cancellation/cancellation.component';
// import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NewHomeComponent } from './common/new-home/new-home.component';

register();

const routes: Routes = [
  // Define your routes here
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64] // Optional: Adjust the scroll offset if needed
};
@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        MiteventsComponent,
        ContactComponent,
        SingleEventComponent,
        FutekCasestudyComponent,
        EventfooterComponent,
        PrivacyComponent,
        TermsandConditionsComponent,
        TermsandConditionsComponent,
        CancellationComponent,
        NewHomeComponent,

    ], schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [RouterModule],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        AppRoutingModule,
        // SlickCarouselModule,
        ServicesModule,
        BrowserAnimationsModule,
        CarouselModule,
        MatTabsModule,
        SharedModule,
        FontAwesomeModule,
        IndustriesModule,
        CareersModule, AboutModule,
        InsightsModule,
        ReactiveFormsModule,
        FormsModule,
        MatCardModule,
        NgxIntlTelInputModule,

        // NgxMaterialIntlTelInputComponent,
        MatDialogModule, CareersRoutingModule, InsightsRoutingModule, ServicesRoutingModule, IndustriesRoutingModule,
        RouterModule.forRoot(routes, routerOptions)], providers: [
        provideClientHydration(),
        provideHttpClient(withFetch()),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
